export function LogoMark({ size = 34, className = "" }) {
    return (
        <img
            src="/logo.png"
            alt="Science & Surgical logo"
            width={size}
            height={size}
            className={className}
            style={{ width: size, height: size, objectFit: "contain" }}
            data-testid="brand-logo-mark"
        />
    );
}

export function Wordmark({ compact = false }) {
    return (
        <span
            className={`font-display font-extrabold uppercase leading-none tracking-tight ${
                compact ? "text-base" : "text-lg"
            }`}
            data-testid="brand-wordmark"
        >
            Science<span className="mx-1 text-accent">&amp;</span>Surgical
        </span>
    );
}
